<template>
  <div>
    <el-dialog
      title="编辑其他专职专业人员"
      :visible="add"
      :rules="rules"
      width="540px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <div v-if="!detailShow">
        <el-form
          label-position="top"
          :rules="rules"
          :model="data"
          ref="form"
          label-width="140px"
          class="formTotal"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="姓名" prop="name">
                <el-input
                  v-model="data.name"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row style="display: flex; align-items: flex-start">
            <el-col :span="8">
              <el-form-item prop="idcard" label="身份证号">
                <el-input
                  v-model="data.idcard"
                  placeholder="请输入身份证号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="margin-left: 30px">
              <el-form-item label="身份证（正面）" prop="idcard_f_image">
                <Upload :files.sync="data.idcard_f_image" class="mt5" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证（反面）" prop="idcard_b_image">
                <Upload :files.sync="data.idcard_b_image" class="mt5" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item prop="major" label="专业">
                <el-input
                  v-model="data.major"
                  placeholder="请输入专业"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item prop="phone" label="联系电话">
                <el-input
                  v-model="data.phone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item prop="title" label="职称">
                <el-select v-model="data.title" placeholder="请选择">
                  <el-option
                    v-for="item in zj_level"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" style="margin-top: 20px">
              <!--              todo-->
              <!--              这里字段更换过-->
              <el-form-item prop="cert_name" label="具备执(从)业资格证书名称">
                <el-input
                  v-model="data.cert_name"
                  placeholder="请输入具备执(从)业资格证书名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="注册证书编号" prop="cert_number">
                <el-input
                  v-model="data.cert_number"
                  placeholder="请输入注册证书编号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="证书有效期" prop="cert_exp_time">
                <el-date-picker
                  v-model="data.cert_exp_time"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
                <!--                <el-date-picker-->
                <!--                  v-model="data.exp_time"-->
                <!--                  value-format="yyyy-MM-dd"-->
                <!--                  type="daterange"-->
                <!--                  range-separator="至"-->
                <!--                  start-placeholder="开始日期"-->
                <!--                  end-placeholder="结束日期"-->
                <!--                >-->
                <!--                </el-date-picker>-->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" style="margin-top: 5px">
              <el-form-item label="具备执（从）业资格证书" prop="cert_image">
                <Upload :files.sync="data.cert_image" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" style="margin-top: 5px">
              <el-form-item label="职称证书" prop="title_image">
                <Upload :files.sync="data.title_image" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-else>
        <div class="contControll">
          <div class="them"></div>
          <div class="cont">
            <div class="item">
              <div class="text">姓名</div>
              <div class="detail">{{ row.name }}</div>
            </div>
            <div class="item">
              <div class="text">身份证号</div>
              <div class="detail">{{ row.idcard }}</div>
            </div>
            <div class="item">
              <div class="text">身份证（正面）</div>
              <div class="detail" v-if="row.idcard_f_image">
                <a
                  :href="row.idcard_f_image | domainSrc"
                  target="_blank"
                  class="link"
                >查看文件</a
                >
              </div>
              <div v-else>暂无</div>
            </div>
            <div class="item">
              <div class="text">身份证（反面）</div>
              <div class="detail" v-if="row.idcard_b_image">
                <a
                  :href="row.idcard_b_image | domainSrc"
                  target="_blank"
                  class="link"
                >查看文件</a
                >
              </div>
              <div v-else>暂无</div>
            </div>
            <div class="item">
              <div class="text">专业</div>
              <div class="detail">{{ row.major ? row.major : "暂无" }}</div>
            </div>
            <div class="item">
              <div class="text">联系电话</div>
              <div class="detail">{{ row.phone ? row.phone : "暂无" }}</div>
            </div>
            <div class="item">
              <div class="text">职称</div>
              <div class="detail">{{ row.title ? row.title : "暂无" }}</div>
            </div>
            <div class="item">
              <div class="text">具备执(从)业资格证书名称</div>
              <div class="detail">
                {{ row.cert_name ? row.cert_name : "暂无" }}
              </div>
            </div>
            <div class="item">
              <div class="text">注册证书编号</div>
              <div class="detail">
                {{ row.cert_number ? row.cert_number : "暂无" }}
              </div>
            </div>
            <div class="item">
              <div class="text">证书有效期</div>
              <div class="detail">
                <!--                {{ row.cert_exp_start_time }}至{{ row.cert_exp_finish_time }}-->
                {{ row.cert_exp_time ? row.cert_exp_time : "暂无" }}
              </div>
            </div>
            <div class="item">
              <div class="text">具备执（从）业资格证书</div>
              <div class="detail" v-if="row.cert_image">
                <a
                  :href="row.cert_image | domainSrc"
                  target="_blank"
                  class="link"
                >查看文件</a
                >
              </div>
              <div v-else>暂无</div>
            </div>
            <div class="item">
              <div class="text">职称证书</div>
              <div class="detail" v-if="row.title_image">
                <a
                  :href="row.title_image | domainSrc"
                  target="_blank"
                  class="link"
                >查看文件</a
                >
              </div>
              <div v-else>暂无</div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div v-if="!detailShow">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="save_line">
            <template v-if="idx"> 确 定</template>
            <template v-else>
              <!--              {{ detailShow ? "确认" : "确认编辑 " }}-->
              {{ detailShow ? "确认" : "确定 " }}
            </template>
          </el-button>
        </div>
        <div v-else><el-button @click="handleClose">确 定</el-button></div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Upload from "@/components/record/Upload";

export default {
  components: {
    Upload
  },
  name: "AddStaff",
  props: {
    //查看详情不显示下面的操作按钮
    // footerBtn: {
    //   type: Boolean,
    //   default: true,
    // },
    //add是从父组件接收过来的，下面的代码会修改到add，就不建议修改这个值
    add: {
      type: Boolean,
      default: false
    },
    idx: {
      type: Number,
      default: -1
    },
    line_data: {
      type: Object,
      default: null
    },
    tableData: {
      type: Array,
      default: null
    },
    detailShow: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => {
      }
    }
  },
  created() {
    //add为 外面操作弹窗的开关状态
    this.dialogVisible = this.add;
    //编辑的时候会有每一行
    if (this.line_data) {
      //data里面的键也有name, idcard_f_image这些不然后台没键会报错
      this.data = Object.assign({}, this.line_data);
    }

    //原来的证书时间是有两个 开始和结束 现在只要一个了 上面的日期组件也不用range区间的方式了
    // if (this.data && this.data.cert_exp_time) {
    //   let time_arr = this.data.cert_exp_time.split("至");
    //   this.data.exp_time = [];
    //   this.data.exp_time.push(time_arr[0]);
    //   this.data.exp_time.push(time_arr[1]);
    // }

    this.table_data = this.tableData;
  },
  watch: {
    data: {
      handler(val) {
        for (let item in val) {
          if (val[item] && item.includes("image")) {
            let arr = [];
            if (this.$refs.form) {
              arr = Object.keys(this.$refs.form);
            }
            if (arr.length > 0) {
              this.$refs.form.clearValidate(item);
            }
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      id: -1,
      table_data: [],
      dialogVisible: false,
      data: {
        name: "",
        idcard: "",
        idcard_f_image: "",
        idcard_b_image: "",
        major: "",
        phoen: "",
        title: "",
        cert_name: "",
        // exp_time: [],
        // cert_start_time: "",
        // cert_finish_time: "",
        cert_exp_time: "", //证书有效期
        // cert_exp_start_time: "", //注册证书有效期开始
        // cert_exp_finish_time: "", //注册证书有效期结束

        cert_image: "", //具备执（从）业资格证书
        title_image: "" //职称证书
      },
      zj_level: [
        {
          label: "技术员",
          value: "技术员"
        },
        {
          label: "助理工程师",
          value: "助理工程师"
        },
        {
          label: "工程师",
          value: "工程师"
        },
        {
          label: "高级工程师",
          value: "高级工程师"
        },
        {
          label: "正高级工程师",
          value: "正高级工程师"
        }
      ],
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        idcard: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          {
            message: "身份证号码格式不对",
            trigger: "blur",
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
          }
        ],
        major: [
          {
            required: true,
            message: "请输入专业",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          },
          {
            pattern: /^1\d{10}$/,
            message: "手机号格式不对",
            trigger: "blur"
          }
        ],
        title: [
          {
            required: true,
            message: "请选择职称",
            trigger: ["blur", "change"]
          }
        ],
        cert_exp_time: [
          {
            required: true,
            message: "请输入证书有效期",
            trigger: ["blur", "change"]
          }
        ],
        cert_name: [
          {
            required: true,
            message: "请输入具备执(从)业资格证书名称",
            trigger: "blur"
          }
        ],
        cert_number: [
          {
            required: true,
            message: "请输入注册证书编号",
            trigger: "blur"
          }
        ],
        title_image: [
          {
            required: true,
            message: "请上传职称证书",
            trigger: "change"
          }
        ],
        cert_image: [
          {
            required: true,
            message: "请上传资格证书",
            trigger: "change"
          }
        ],
        idcard_b_image: [
          {
            required: true,
            message: "请上传身份证（反面）",
            trigger: "change"
          }
        ],
        idcard_f_image: [
          {
            required: true,
            message: "请上传身份证（正面）",
            trigger: "change"
          }
        ]
      }
    };
  },
  filters: {
    domainSrc(src) {
      // let temsrc = src.replace(/https:\/\/zjzxadmin.jc881.com/g, "");
      let temsrc = src.replace(/http:\/\/zjqyadmin.ynbzde.com/g, "");
      // return "https://zjzxadmin.jc881.com/" + temsrc;
      return "http://zjqyadmin.ynbzde.com/" + temsrc;
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      // this.add = false;
      this.$emit("update:add", false);
    },
    // beforeClose() {
    //   // this.save_line();
    // },
    //确认编辑提交
    save_line() {
      let tempImgs = [
        "cert_image",
        "idcard_b_image",
        "idcard_f_image",
        "title_image"
      ];
      let tepVal = "";
      tempImgs.forEach((item2) => {
        tepVal = this.data[item2];
        console.log(tepVal);
        // TODO 正是站这里没有https(建设厅服务器安装不了https证书)
        if (tepVal) {
          //测试域名
          // tepVal = tepVal.replace(/https:\/\/zjzxadmin.jc881.com/g, "");
          //正式域名
          tepVal = tepVal.replace(/http:\/\/zjqyadmin.ynbzde.com/g, "");
          this.data[item2] = tepVal;
        }
      });
      console.log(this.data, "<><><>");

      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.$message.success("添加成功！");

          if (this.idx !== -1) {
            this.$set(this.table_data, this.idx, this.data);
          } else {
            //添加新的行数
            this.table_data.push(this.data);
          }
          this.$emit("update:tableData", this.table_data); //更新父级的表格数据
          this.handleClose();
        } else {
          this.$message.error("请提交完整！");
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-form--label-top .el-form-item__label {
  padding: unset;
  font-size: 12px;
  color: #666666;
}

/deep/ .el-form-item__label {
  line-height: unset;
}

/deep/ .el-input__inner {
  margin-top: 5px;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #dddddd;
}

/deep/ .el-dialog__footer {
  background: #f5f5f5;
  height: 70px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
}

.dialog-footer {
  /deep/ .el-button--primary {
    width: 100px;
    background: #f39020;
  }

  /deep/ .el-button {
    padding: unset;
    width: 100px;
    height: 32px;
    border-radius: unset;
  }
}

.t {
  margin-top: 20px;
  font-size: 12px;
  color: #666666;
}

.mt5 {
  margin-top: 5px;
}

.contControll {
  display: flex;
  align-items: flex-start;

  .them {
    min-width: 110px;
    font-size: 12px;
    font-weight: 700;
    color: #333333;
  }

  .cont {
    flex: 1;

    .item {
      display: flex;
      align-items: center;
      margin-top: 16px;

      &:first-child {
        margin-top: unset;
      }

      .text {
        font-size: 12px;
        color: #999999;
        width: 190px;
      }

      .detail {
        font-size: 12px;
        color: #333333;
      }

      .check {
        font-size: 12px;
        color: #4379f6;
        cursor: pointer;
      }
    }
  }
}
</style>
